module.exports = __webpack_public_path__ + "img/2.72674867.png";